import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
// import 'default-passive-events';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import 'babel-polyfill';
// 引入echarts
import echarts from "echarts";
// import './mock' // 一定要在 mian.js 导入 mock 文件
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
// import 'lib-flexible/flexible.js'

import '../src/utils/flexible.js'
Vue.config.productionTip = false;

Vue.use(ElementUI, {
    size: 'small'
});
Vue.prototype.$echarts = echarts;
//高德地图
import VueAMap  from 'vue-amap'
Vue.use(VueAMap);
// 初始化vue-amap
VueAMap.initAMapApiLoader({
  // 申请的高德key
  key: 'f94db8278a4a31d68433f7824ce33d78',
  // 插件集合
  plugin: [ 'ToolBar','Geolocation','Geocoder','MarkerClusterer','Autocomplete','PlaceSearch'],
  v: '1.4.15', // SDK 版本
  uiVersion: '1.0.11' // ui版本号，也是需要写
});
// import resetSetItem from "./utils/storage";
// Vue.prototype.resetSetItem = resetSetItem;

Vue.prototype.resetSetItem = function (key, newVal) {
    if (key === 'languageType') {
        // 创建一个StorageEvent事件
        var newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
            setItem: function (k, val) {
                sessionStorage.setItem(k, val);
                // 初始化创建的事件
                newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
                // 派发对象
                window.dispatchEvent(newStorageEvent)
            }
        }
        return storage.setItem(key, newVal);
    }
 }
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} | 北京普发动力控股股份有限公司`;
    next();
    // const role = localStorage.getItem('ms_username');
    // if (!role && to.path !== '/login') {
    //     next('/login');
    // } else if (to.meta.permission) {
    //     // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    //     role === 'admin' ? next() : next('/403');
    // } else {
    //     // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
    //     if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
    //         Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
    //             confirmButtonText: '确定'
    //         });
    //     } else {
    //         next();
    //     }
    // }
});

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
